import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { UsersService } from "../../../../services/users.service";
import { GeneralItemDetailDialogComponent } from "../../../../shared-components/general-item-detail-dialog/general-item-detail-dialog.component";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Customer } from "../../../../model/customer";
import { EMPTY, Observable, of } from "rxjs";
import { DialogsService } from "../../../../services/dialogs.service";
import { SnackService } from "../../../../services/snack.service";
import { switchMap, tap } from "rxjs/operators";
import { Sort } from "@angular/material/sort";
import { CreateCustomerDialogComponent } from "../create-customer-dialog/create-customer-dialog.component";
import { ActivatedRoute, Router } from "@angular/router";
import { CompaniesService } from "../../../../services/companies.service";
import { Constants } from "../../../../utils/constants";
import { merge } from "lodash-es";

@Component({
  selector: 'aw-list-customers',
  templateUrl: './list-customers.component.html',
  styleUrls: ['./list-customers.component.scss']
})
export class ListCustomersComponent implements OnInit, AfterViewInit {

  public displayedColumns = [

    'firstName',
    'lastName',
    'email',
    'phone',
    'company',
    'enabled',
    'action'
  ];
  disabled = false;
  disabledItemId: number[] = [];
  loading = false;
  isUserEnabled?= false;
  @ViewChild('#paginatorCustomers') paginatorUsers!: MatPaginator;
  dataSource!: MatTableDataSource<Customer>;
  @Input() companyId?: number;
  @Input() embeddedLayout = false;
  private allCustomers$!: Observable<Customer[]>;
  entities = Constants.entities;
  roles = Constants.roles;

  constructor(
    public dialog: MatDialog,
    private usersService: UsersService,
    private companyService: CompaniesService,
    private dialogsService: DialogsService,
    private snackService: SnackService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.allCustomers$ =
      of(true).pipe(
        tap(() => this.loading = true),
        switchMap(() => {
          if (this.companyId)
            return this.usersService.getAllCustomersByCompany(this.companyId);
          else
            return this.usersService.getAllCustomers();
        }),
        tap((x) => {
          this.dataSource = new MatTableDataSource<Customer>(x);
          this.dataSource.paginator = this.paginatorUsers;
          this.loading = false;
        })
      );
    this.allCustomers$.subscribe();
  }

  applyFilters(event: string): void {

    this.dataSource.filter = event.trim().toLowerCase();
  }

  doSortUsers(event: Sort): void {
    this.dataSource.paginator?.firstPage();
    this.dataSource.data = this.dataSource.data.sort((a, b) => {


      if (event.active === 'id') {
        if (event.direction === 'asc') {
          return ('' + b.id).localeCompare('' + a.id);
        } else {
          return ('' + a.id).localeCompare('' + b.id);
        }
      }

      if (event.active === 'firstName') {
        if (event.direction === 'asc') {
          return ('' + b.firstName).localeCompare('' + a.firstName);
        } else {
          return ('' + a.firstName).localeCompare('' + b.firstName);
        }
      }

      if (event.active === 'lastName') {
        if (event.direction === 'asc') {
          return ('' + b.lastName).localeCompare('' + a.lastName);
        } else {
          return ('' + a.lastName).localeCompare('' + b.lastName);
        }
      }

      if (event.active === 'email') {
        if (event.direction === 'asc') {
          return ('' + b.email).localeCompare('' + a.email);
        } else {
          return ('' + a.email).localeCompare('' + b.email);
        }
      }

      if (event.active === 'phone') {
        if (event.direction === 'asc') {
          return ('' + b.phone).localeCompare('' + a.phone);
        } else {
          return ('' + a.phone).localeCompare('' + b.phone);
        }
      }

      if (event.active === 'company') {
        if (event.direction === 'asc') {
          return ('' + b.company?.companyName).localeCompare('' + a.company?.companyName);
        } else {
          return ('' + a.company?.companyName).localeCompare('' + b.company?.companyName);
        }
      }

      return -1;


    }
    );
  }

  details(user: Customer): void {
    this.dialog.open(GeneralItemDetailDialogComponent, { data: user });
  }

  createUser(): void {
    this.disabled = true;
    this.dialog
      .open(CreateCustomerDialogComponent, { data: new Customer() })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allCustomers$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        },
        () => {
          this.disabled = false;
        });
  }

  editUser(user: Customer): void {
    this.disabled = false;
    this.dialog
      .open(CreateCustomerDialogComponent, { data: user })
      .afterClosed()
      .pipe(switchMap(value => value ? this.allCustomers$ : EMPTY))
      .subscribe(
        () => {
          this.disabled = false;
        },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        },
        () => {
          this.disabled = false;
        });
  }

  deleteUser(customer: Customer): void {
    this.disabled = true;
    const id = customer.id ?? -1;
    this.disabledItemId.push(id);
    this.dialogsService
      .confirm('Delete customer', `Are you sure you want to delete the customer "${customer.firstName} ${customer.lastName}"?`)
      .pipe(
        switchMap((value) => value ?
          this.usersService.deleteCustomer(<number>customer.id) :
          EMPTY),
        switchMap(() => this.allCustomers$)
      )
      .subscribe(() => {
        this.disabled = false;
        this.snackService.success('Customer deleted!');
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      }, (error) => {
        this.snackService.error(error.message);
        this.disabled = false;
        this.disabledItemId.splice(this.disabledItemId.indexOf(id), 1);
      },
        () => {
          this.disabled = false;
        });
  }

  changeCustomerHabilitation(customer: Customer): void {
    this.disabled = true;
    const editedCustomer = merge(new Customer(), customer);
    editedCustomer.enabled = !customer.enabled;
    const keyword = editedCustomer.enabled ? 'enable' : 'disable';
    this.dialogsService
      .confirm(`${keyword.toUpperCase()} customer`, `Are you sure you want to ${keyword} the customer "${customer.firstName} ${customer.lastName}"?`)
      .pipe(
        switchMap((value) => value ? this.usersService.updateCustomer(editedCustomer) : EMPTY),
        switchMap(() => this.allCustomers$)
      )
      .subscribe(() => {
        this.snackService.success(`Customer ${keyword}d!`);
        this.disabled = false;
      },
        (error) => {
          this.snackService.error(error.message);
          this.disabled = false;
        },
        () => {
          this.disabled = false;
        });
  }
}
